import { useQuery } from '@tanstack/react-query';
import { scenarioApi, scenarioKeys } from '../api';

/**
 * 붙어 있는 폼의 지금 상태 (퀘스트 8042eca6 CP4).
 *
 * **팝오버를 열 때만 켠다**(`enabled`) — 계약 확인이 구글 왕복이라, 칩 줄을 그리는 것만으로
 * 그 비용을 내면 안 된다. 폼이 없는 캠페인은 볼 상태가 없어 서버가 400 을 내므로 아예 끈다.
 */
export function useOutreachFormStatus(scenarioId: string, enabled: boolean) {
  return useQuery({
    queryKey: scenarioKeys.outreachFormStatus(scenarioId),
    queryFn: () => scenarioApi.outreachFormStatus(scenarioId),
    enabled: enabled && scenarioId.length > 0,
    // 열 때마다 다시 본다 — 그 사이 남이 발송해 잠갔을 수 있다.
    staleTime: 0,
  });
}

/** 덮개 배너가 보는 감시 상태. 폼이 없으면 끈다. */
export function useOutreachFormWatch(scenarioId: string, enabled: boolean) {
  return useQuery({
    queryKey: scenarioKeys.outreachFormWatch(scenarioId),
    queryFn: () => scenarioApi.outreachFormWatch(scenarioId),
    enabled: enabled && scenarioId.length > 0,
  });
}
